import {
  getInt32,
} from "@surya-digital/leo-ts-types";

export interface BoUserManagementPageIndexDTO {
  items: number;
}

export class BoUserManagementPageIndex {
  readonly isBoUserManagementPageIndexBoUserManagementPageIndex: boolean = true;

  readonly items: number;

  static readonly constraints = {
    "items": {
      "minValue": 0,
    }
  }

  constructor(
  items: number
  ) {
    BoUserManagementPageIndex.validateItems(items);
    this.items = items;
  }

  static fromDTO(dto: BoUserManagementPageIndexDTO): BoUserManagementPageIndex {
    const items = getInt32(dto, "items", InvalidBoUserManagementPageIndexItemsError);
    return new BoUserManagementPageIndex(
      items
    );
  }

  toDTO(): BoUserManagementPageIndexDTO {
    const dto: BoUserManagementPageIndexDTO = {
        items: this.items
    };
    return dto;
  }
  private static validateItems = (items: number): void => {
    if(items < 0) {
      throw new InvalidBoUserManagementPageIndexItemsMinValueError(
        0,
        `Attribute items has value ${items}. Min value is 0.`
      );
    }
  }
  
}

BoUserManagementPageIndex.prototype.toString = function toString(): string {
  return `BoUserManagementPageIndex(items='${this.items}')`;
};

export class InvalidBoUserManagementPageIndexError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBoUserManagementPageIndexError";
  }
}
export class InvalidBoUserManagementPageIndexItemsError extends InvalidBoUserManagementPageIndexError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBoUserManagementPageIndexItemsError";
  }
}

export class InvalidBoUserManagementPageIndexItemsMinValueError extends InvalidBoUserManagementPageIndexItemsError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBoUserManagementPageIndexItemsMinValueError";
  }
}
